// The school-day streak with storage: reads the ledger and revault:streak, settles it, and writes it
// back only when something changed. Used by the start page card and the Island (both lazy chunks),
// which hand in the app's ledger (A = shared/activity.js) and, when they have it, the app's store so
// its listeners hear the write.
import { STREAK_KEY, DEVICE_KEY, calendar, load, toggleOff, clean, dateKey } from "./streak.js";
// What the card and the Island draw with, so they need only this one chunk.
export { streakText, freezeText, offChoices } from "./streak.js";

const plain = {
	readJSON: (k, f) => { try { const v = localStorage.getItem(k); return v == null ? f : JSON.parse(v); } catch { return f; } },
	writeJSON: (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch { /* storage off */ } },
	remove: (k) => { try { localStorage.removeItem(k); } catch { /* storage off */ } },
};

function device() {
	try {
		let v = localStorage.getItem(DEVICE_KEY);
		if (!v || !/^[a-z0-9]{6,24}$/.test(v)) { v = Math.random().toString(36).slice(2, 12) + Date.now().toString(36); localStorage.setItem(DEVICE_KEY, v); }
		return v;
	} catch { return ""; }
}

// { view, state, cal } or null while the ledger is paused (incognito, history off) or the streak is hidden.
export function streakNow(get, A, io = plain, now = new Date()) {
	if (get("streakShow") === false || !A.enabled()) return null;
	const raw = io.readJSON(STREAK_KEY, null);
	const cal = calendar(get, raw && Array.isArray(raw.off) ? raw.off : []);
	const r = load(raw, A.days(), cal, now, device());
	if (r.changed) io.writeJSON(STREAK_KEY, r.state);
	return { view: r.view, state: r.state, cal };
}

export function markOff(key, io = plain, now = new Date()) {
	const s = clean(io.readJSON(STREAK_KEY, null), dateKey(now));
	if (s) io.writeJSON(STREAK_KEY, toggleOff(s, key, now));
}
export function dismissWelcome(io = plain) {
	const s = io.readJSON(STREAK_KEY, null);
	if (s && typeof s === "object" && s.wb === 1) io.writeJSON(STREAK_KEY, Object.assign({}, s, { wb: 0 }));
}
export function clearStreak(io = plain) { io.remove(STREAK_KEY); }
